import React, { useState, useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { connect, useSelector } from 'react-redux'
import store from '../store'
import { setInvoiceAttachments, removeInvoiceAttachments } from '../actions'
import FontAwesome from 'react-fontawesome'
import IconButton from '@material-ui/core/IconButton'
import Button from '@material-ui/core/Button'
import i18next from 'i18next'
import mobileView from './mobile.utils'

function Dropzone({ formFiles = [], setFormFiles }) {
  //props
  const [showTick, setShowTick] = useState(false)

  const invoicePreviewAttachments = useSelector(
    (state) => state.invoiceReviews.attachments
  )

  const isFileAttached = (file) => {
    return invoicePreviewAttachments.some((att) => att.filename === file.name)
  }

  const onDrop = useCallback((acceptedFiles) => {
    if ([...formFiles, ...acceptedFiles].length <= 5) {
      setFormFiles([...formFiles, ...acceptedFiles])
      setShowTick(false)
    }
  })

  const { getRootProps, getInputProps } = useDropzone({
    accept: ['image/png', 'image/jpeg', 'application/pdf'],
    onDrop
  })

  const removeFile = (file) => () => {
    const newFiles = [...formFiles]
    newFiles.splice(newFiles.indexOf(file), 1)
    setFormFiles(newFiles)
  }

  const removeAll = () => {
    setFormFiles([])
    setShowTick(false)
    store.dispatch(removeInvoiceAttachments())
  }

  async function uploadWithJSON(file) {
    const toBase64 = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = (error) => reject(error)
      })

    let attachment = {
      filename: file.name,
      filetype: file.type,
      data: await toBase64(file)
    }
    return attachment
  }

  const attachAll = () => {
    const attachments = async () => {
      return Promise.all(formFiles.map((file) => uploadWithJSON(file)))
    }

    attachments().then((data) => {
      //console.log(data)
      store.dispatch(setInvoiceAttachments(data))
    })

    setShowTick(true)
  }

  const formatFileName = (name) => {
    if (name.length > 28) {
      return `${name.slice(0, 11)}...${name.slice(-8)}`
    }
    return name
  }

  const files = formFiles.map((file) => (
    <li
      key={file.path}
      style={{
        display: 'block',
        position: 'relative',
        float: 'left',
        textAlign: 'center',
        color: '#44C0CC'
      }}
    >
      {formatFileName(file.path)}
      {isFileAttached(file) ? (
        <IconButton aria-label="Attached">
          <FontAwesome name="check-square" style={{ color: '#82c91e' }} />
        </IconButton>
      ) : (
        <IconButton aria-label="Delete" onClick={removeFile(file)}>
          <FontAwesome name="window-close" style={{ color: '#F67131' }} />
        </IconButton>
      )}
    </li>
  ))

  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: mobileView ? 'center' : '',
    padding: '20px',
    borderWidth: 2,
    borderRadius: '7px',
    borderColor: '#44C0CC',
    borderStyle: 'dashed',
    backgroundColor: '#EAFDFC',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    height: '100%'
  }

  return (
    <section
      className="container-fluid"
      style={{ padding: 0, height: '250px', marginBottom: '50px' }}
    >
      <div {...getRootProps({ className: 'dropzone', style: baseStyle })}>
        <input {...getInputProps()} />
        <p>{i18next.t('dropzone.dropInfo')}</p>
      </div>
      {files.length > 0 ? (
        <aside>
          <ul>{files}</ul>
        </aside>
      ) : (
        ''
      )}

      {files.length > 0 ? (
        <ul className="nav nav-pills pull-right">
          {!showTick ? (
            <p style={{ marginTop: '15px' }}>
              {i18next.t('dropzone.attachBtnInfo')}
            </p>
          ) : (
            <p style={{ marginTop: '15px', color: '#82c91e' }}>
              {i18next.t('dropzone.attachSuccessMsg')}
            </p>
          )}
          <li>
            <Button
              variant="contained"
              style={{
                marginTop: '15px',
                backgroundColor: '#F67131',
                color: 'white',
                fontSize: '12px'
              }}
              onClick={removeAll}
            >
              {i18next.t('dropzone.removeAll')}
            </Button>
          </li>
          <li>
            <Button
              variant="contained"
              style={{
                marginTop: '15px',
                backgroundColor: '#F67131',
                color: 'white',
                fontSize: '12px'
              }}
              onClick={attachAll}
            >
              {i18next.t('dropzone.attachAll')}
            </Button>
          </li>
        </ul>
      ) : null}
    </section>
  )
}

export default connect()(Dropzone)
